import { useEffect } from "react";
import { useUserManagementStore } from "src/hooks/stores";
import UserForm from "@components/forms/UserForm/UserForm";
import { useParams } from "react-router-dom";
import Spacing from "@vfuk/core-spacing/";
import { useTranslation } from "react-i18next";
import manageAccessBanner from "@img/manageAccessBanner.png";
import { Grid, GridColumn, GridRow } from "@vfuk/core-grid";
import { SectionBanner, Crumbs, SpinnerLoader } from "@ucchub/ui";
import DashShell from "@components/common/DashShell";
import breadCrumbs from "@json/common/crumbs.json";

const EditUser = () => {
  const { t } = useTranslation();
  const { email } = useParams();

  const {
    fetched: userFetched,
    loading: userLoading,
    call: fetchUser,
  } = useUserManagementStore((state) => state.fetchUser);
  const user = useUserManagementStore((state) => state.user);

  useEffect(() => {
    // ensure that the 'email' param exists & we haven't fetched
    if (!userFetched && email) {
      fetchUser(email);
    }
  }, [email, fetchUser, userFetched]);

  return (
    <DashShell>
      <Crumbs items={breadCrumbs.view_Users} />
      <SectionBanner
        heading={userLoading ? t("shared:users:loading") : user.email}
        subtitle=""
        image={manageAccessBanner}
        iconName="admin"
      />

      {userLoading && (
        <SpinnerLoader
          srText={
            t("shared:users:loading_user_details") || "Loading user details"
          }
          text={
            t("shared:users:loading_user_details") || "Loading user details"
          }
        />
      )}

      {!userLoading && (
        <div className="editUserBG">
          <Grid maxWidth="spring">
            <Spacing
              spacingLevel={{
                top: 4,
                bottom: 4,
              }}
            >
              <GridRow justify="center">
                <GridColumn col={12} colMd={8} colLg={6}>
                  <UserForm user={user} />
                </GridColumn>
              </GridRow>
            </Spacing>
          </Grid>
        </div>
      )}
    </DashShell>
  );
};

export default EditUser;
